import { useAuth } from '@platform/auth-client';
import type { TypedClient } from '@platform/openapi';
import { STATISTICS_ROLE } from '../../statistics/statistics.ts';
import { ProductFigures } from './ProductFigures.tsx';
import { ProductMovements } from './ProductMovements.tsx';
import styles from './ProductStatistics.module.css';

export type ProductStatisticsPanelProps = { api: TypedClient; productId: string };

export const ProductStatisticsPanel = ({ api, productId }: ProductStatisticsPanelProps) => {
  const mayReadStatistics = useAuth().hasRole(STATISTICS_ROLE);
  return (
    <div className={styles['panel']}>
      {mayReadStatistics ? <ProductFigures api={api} productId={productId} /> : null}
      <ProductMovements api={api} productId={productId} />
    </div>
  );
};
